import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  cities: [],
  languages: [],
  occupations: [],
  skills: [],
  worklocations: []
}

const store = {
  state,
  actions,
  getters,
  mutations
}

export default store



// WEBPACK FOOTER //
// ./src/store/modules/resources/index.js